import {ChangeDetectionStrategy, Component, EventEmitter, Input, Output} from "@angular/core";
import {BehaviorSubject} from "rxjs";

@Component({
  selector: "n-modal-header",
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: "./n-modal-header.html",
  styleUrls: [
    "./n-modal-header.css",
  ],
})
export class NModalHeaderComponent {

  @Input()
  text: string;

  @Input()
  noClose: boolean;
  sticky$ = new BehaviorSubject<boolean>(false);

  @Output() onClose = new EventEmitter();

}
